import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {withStyles} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
  Typography
} from "@material-ui/core";

import {reverseUserRoute} from 'routes';
import ProductImage from 'components/Image/ProductImage';

import LazyLoad from 'react-lazyload';

const styles = theme => ({
  root: {
    marginTop: theme.spacing(3),
    // minWidth: '770px'
    overflow: 'auto'
  },
  table: {
  },
  tableRow: {
    position: 'relative'  // This enables the :after pseudo element on the <Link> to expand to the size of the row
  },
  tableCell: {
    padding: '14px 40px 14px 16px',
    [theme.breakpoints.down("sm")]: {
      padding: '8px 4px'
    },
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    }
  },
  progress: {
    margin: theme.spacing(2),
  },
  imageColumn: {
    height: 200,
    width: 200
  },
  imageFrame: {
    // background: "linear-gradient(to right, #45B5F2 0%, #249ddd 100%)",
    boxShadow: "5px 5px 10px 0px rgba(0,0,0,0.20)",
    borderRadius: "4px",

    paddingLeft: '4px',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingRight: '4px',

    width: 140,
    height: 100,

    [theme.breakpoints.down('sm')]: {
      width: 60,
      height: 60,
      padding: '2px 2px',
    }
  },
  results: {
    padding: '15px 14px',
  },
  link: {
    color: 'inherit',
    textDecoration: 'none',
    '&:after': {
      // content: '""',
      // position: 'absolute',
      // top: 0,
      // bottom: 0,
      // left: 0,
      // right: 0,
      // backgroundColor: '',
      // color: 'blue'
    }
  },

  lazyLoadDefault: {
    height: '100%',
    width: '100%',
    backgroundSize: 'cover',
    background: "url('data:image/png;base64,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')"
  },
  image: {
    objectFit: 'cover',
    width: '100%',
    height: '100%',
  },
  hidden: {
    [theme.breakpoints.down("sm")]: {
      display: 'none'
    }
  },
});

const Headers = [
  {label: 'Your Items', tooltip: '', hidden: true},
  {label: 'Title', tooltip: ''},
  {label: 'SKU', tooltip: ''},
  {label: 'Category', tooltip: ''},
  {label: 'On hand', tooltip: 'Actual quantity in the warehouse'},
  {label: 'Available', tooltip: 'Total after all open orders are fulfilled'}
]


class SimpleTable extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  render() {

    const {classes, mapColor, itemsSearch} = this.props;
    const spaceUrl = reverseUserRoute('Space')

    return (
      <Paper className={classes.root}>
        <Typography
          color="textSecondary"
          variant="body2"
          className={classes.results}
        >
          {itemsSearch.length} Records found.
        </Typography>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {Headers.map(header => (
                <Tooltip key={header.label} title={header.tooltip} placement="top">
                  <TableCell className={header.hidden ? classes.hidden : classes.tableCell}> {header.label}</TableCell>
                </Tooltip>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {itemsSearch.map(row => (
              <TableRow
                key={row.id}
                hover
                className={classes.tableRow}
              >
                <TableCell className={classes.hidden} component='th' scope='row' >
                  <Link to={`${spaceUrl}/${row.id}`} className={classes.imageColumn} key={row.id}>
                    <div className={classes.imageFrame} style={{background: mapColor(row.category)}}>
                      <LazyLoad
                        height={60}
                      // placeholder={<div className={classes.lazyLoadDefault}>aaaa</div>}
                      >
                        {/* <img src={row.image.thumb.url} alt='product' className={classes.image} /> */}
                        <ProductImage image={row.image} archived={row.archived} />
                      </LazyLoad>
                    </div>
                  </Link>
                </TableCell>
                <TableCell align='left' className={classes.tableCell}>
                  <Link
                    to={`${spaceUrl}/${row.id}`}
                    // key={row.id}
                    // color="textPrimary"
                    // component={RouterLink}
                    // variant="h6"
                    className={classes.link}
                  >
                    <Typography>{row.title}</Typography>
                  </Link>
                </TableCell>
                <TableCell className={classes.tableCell} align='left'><Typography>{row.sku}</Typography></TableCell>
                <TableCell className={classes.tableCell} align='left'><Typography>{row.category || "N/A"}</Typography></TableCell>
                <TableCell className={classes.tableCell} align='center'><Typography>{row.quantity_in_storage}</Typography></TableCell>
                <TableCell className={classes.tableCell} align='center'><Typography>{row.quantity_available}</Typography></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

      </Paper>
    );

  }
}

SimpleTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  items: state.spaceReducer.items,
  searchActive: state.spaceReducer.searchActive,

});

// function search(searchTerm, stringToProcess) {
//   let stp = stringToProcess.toLowerCase()
//   let st = searchTerm.toLowerCase()
//   return stp.includes(st)
// }

export default connect(mapStateToProps)(withStyles(styles)(SimpleTable));
